// src/services/feedbackService.ts - VERSIONE FINALE E AUTOMATICA

// 1. Importiamo il nostro apiClient invece di axios
import apiClient from './apiClient';

// 2. La costante API_URL non è più necessaria, è gestita da apiClient.

export async function sendFeedback(callId: string, body: {
  token: string;
  score: number;
  comment?: string;
}) {
  // 3. Usiamo apiClient con un percorso relativo.
  // L'header per ngrok (in sviluppo) e quello di autorizzazione JWT (se l'utente è loggato)
  // verranno aggiunti automaticamente.
  return apiClient.post(`/api/feedback/${callId}`, body);
}